import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable()
export class UserSubscriptionService {
  private apiPrefix = '/admin/user-subscriptions';

  constructor(
    private api: ApiService
  ) {
  }

  getUserSubscriptions(qs = '') {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  cancelUserSubscription(userId: number) {
    return this.api.delete(`${this.apiPrefix}/user/${userId}/unsubscribe`);
  }

  cancelUserSubscriptionWithSubscriptionId(subscriptionId: number) {
    return this.api.delete(`${this.apiPrefix}/subscription/${subscriptionId}/unsubscribe`);
  }

  getUserSubscriptionDetail(subscriptionId: number) {
    return this.api.get(`${this.apiPrefix}/subscription/${subscriptionId}/detail`);
  }
}
